import { defineMessages } from 'react-intl';
export default defineMessages({
  listsPageTitle: {
    id: 'wishlist.lists.title',
    defaultMessage: 'Moje seznamy',
  },
  listsPageDescription: {
    id: 'wishlist.lists.description',
    defaultMessage:
      'Ukládejte, sdílejte a spravujte svoje seznamy kdykoli a kdekoli. Váš wishlist, váš styl!',
  },
});
